import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ReactComponent as VpopPro } from '/static/svg_icons/vpop_pro_icon_colored.svg';
import ApiCalls from 'app/utils/apiCalls';
import { useSelector } from 'react-redux';
import { selectCurrentImageId } from 'app/redux/currentStudyInfos/reducer';
import { Button, Popup } from 'semantic-ui-react';
import winreg from 'app/native/node/winreg';

async function openVPopProOrDisplayInstallationPage(imageUri: string) {
  if (winreg()) {
    const Registry = winreg();
    const regKey = new Registry({
      // new operator is optional
      hive: Registry.HKCR, // open registry hive HKEY_CLASSES_ROOT
      key: '\\vpop', // key containing autostart programs
    });
    await new Promise<void>((resolve, reject) => {
      regKey.keyExists((err, exists) => {
        if (exists) resolve();
        reject(new Error('VpopPro urischeme handler is not installed.'));
      });
    });
  }

  return new Promise<void>((resolve, reject) => {
    // Try to open the URI
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = imageUri;
    document.body.appendChild(iframe);

    // Cleanup after a bit
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 2000);
    const context = {
      timeout: undefined as NodeJS.Timeout | undefined,
      onWindowBlur: undefined as () => void,
    };

    const cleanup = () => {
      clearTimeout(context.timeout);
      context.timeout = undefined;
      window.removeEventListener('blur', context.onWindowBlur);
    };

    context.onWindowBlur = () => {
      console.info('Window blurred, VpopPro is available');
      clearTimeout(context.timeout);
      resolve();
    };

    window.addEventListener('blur', context.onWindowBlur);
    context.timeout = setTimeout(() => {
      cleanup();
      reject(
        new Error('VpopPro did not respond in time. Please install VpopPro to open this image.')
      );
    }, 1500);
  });
}

/**
 * VpopProButton component
 */
function VpopProButton({}) {
  const intl = useIntl();
  const selectedCurrentImageId = useSelector(selectCurrentImageId);
  const [isVPopProInstallPopupDisplayed, setIsVPopProInstallPopupDisplayed] = useState(false);

  const handleClick = async () => {
    try {
      if (!selectedCurrentImageId) {
        console.error('No image ID found in the viewer.');
        return;
      }

      const imageTempUrl = await ApiCalls.getTempUrlImage(selectedCurrentImageId);
      if (!imageTempUrl) {
        console.error('No temporary URL found for the image.');
        return;
      }
      const vpopUrl = `vpop://open-image-url/?location=${encodeURIComponent(imageTempUrl)}`;

      openVPopProOrDisplayInstallationPage(vpopUrl).catch(() => {
        console.warn('VpopPro is not installed or did not respond in time.');
        setIsVPopProInstallPopupDisplayed(true);
      });
    } catch (error) {
      console.error('Failed to send image ID:', error);
    }
  };

  return (
    <Popup
      open={isVPopProInstallPopupDisplayed}
      onClose={() => setIsVPopProInstallPopupDisplayed(false)}
      closeOnDocumentClick
      closeOnTriggerBlur={false}
      closeOnEscape
      closeOnPortalMouseLeave
      closeOnTriggerClick={false}
      closeOnTriggerMouseLeave={false}
      hoverable
      hideOnScroll={false}
      position="bottom center"
      style={{ textAlign: 'center' }}
      trigger={
        <button
          type="button"
          className="picoxia tool-button vpop-pro-button"
          onClick={handleClick}
          title={intl.formatMessage({ id: 'tools.vpop-pro.tooltip' })}
        >
          <i>
            <VpopPro />
          </i>
        </button>
      }
    >
      <Popup.Header>
        <FormattedMessage id="tools.vpop-pro.missing.header" />
      </Popup.Header>
      <Popup.Content>
        <p>
          <FormattedMessage id="tools.vpop-pro.missing.content" />
        </p>
        <Button
          as="a"
          href="https://apps.microsoft.com/detail/9pj9br41pc1l"
          target="_blank"
          rel="noopener noreferrer"
          color="blue"
        >
          <FormattedMessage id="tools.vpop-pro.missing.download" />
        </Button>
      </Popup.Content>
    </Popup>
  );
}

export default VpopProButton;
